<template>
  <div class="xieyi" v-html="content"></div>
</template>

<script>
import qs from "qs";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
  mounted() {
    this.getAgreement();
  },

  methods: {
    getAgreement() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "PRIVACYPOLICY",
      });
      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
             Toast.clear()
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
             Toast.clear()
            this.content = res.data.data.content;
          }
        })
        .catch((err) => {
           Toast.clear()
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
  data() {
    return {
      content: "",
    };
  },
};
</script>

<style lang="scss" scoped>
.xieyi {
  background-color: #fff;
}
</style>